import axios from "axios";
import { useEffect, useState } from "react";
import { usePektaStore, usePengajianStore } from "../helpers/state";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import check from "../../asset/check.png";
import { Header } from "../header";
import { Container, Modal } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";
import { useLoginStore } from "../helpers/state";
import PektaHeader from "../helpers/pektaHeader";
import { CircularProgress } from "@mui/material";
import {
  validateFile,
  shortenFilename,
  validationConfigs,
} from "../helpers/fileValidation";

toast.configure();

export function PektaForm2(setCount) {
  const { login } = useLoginStore();
  const {
    kelayakan,
    updatePengajianField,
    addQualification,
    removeQualification,
    resetQualifications,
  } = usePengajianStore();
  const { nextPage } = usePektaStore();
  const [open, setOpen] = useState(false);
  const qualifications = Array.isArray(kelayakan) ? kelayakan : [];

  useEffect(() => {
    if (!Array.isArray(kelayakan) || !qualifications.length) {
      resetQualifications();
    }
  }, [kelayakan]);

  useEffect(() => {
    // Set first row category to AGAMA if it's empty
    if (qualifications[0] && !qualifications[0].category) {
      updatePengajianField(0, "category", "AGAMA");
    }
  }, [qualifications]);

  const handleChange = (index, e) => {
    const { name, value } = e.target;
    updatePengajianField(index, name, value.toUpperCase());
  };

  const validateAgamaFields = (qualification) => {
    const fields = [
      "type",
      "level",
      "institution",
      "yearPengajian",
      "filePengajian",
    ];
    return fields.every((field) => qualification[field]);
  };

  const validateFirstRow = (qualification) => {
    const requiredFields = [
      "type",
      "level",
      "institution",
      "yearPengajian",
      "filePengajian",
    ];
    return requiredFields.every((field) => qualification[field]);
  };

  const isFieldRequired = (index, qualification, fieldName) => {
    return (
      index === 0 ||
      qualification.category === "AGAMA" ||
      qualification.category === "BUKAN AGAMA"
    );
  };

  const navigate = useNavigate();

  let formData;
  let newArr = [];

  function handleUpload(e) {
    // Validate BEFORE showing loader with row-specific details
    const requiredFields = [
      "category",
      "type",
      "level",
      "institution",
      "yearPengajian",
      "filePengajian",
    ];
    const labelMap = {
      category: "Kategori",
      type: "Bidang",
      level: "Kelulusan Akademik",
      institution: "Institusi",
      yearPengajian: "Tahun",
      filePengajian: "Dokumen Kelayakan",
    };

    const missingByRow = [];
    const emptyRows = [];
    const firstQual = qualifications[0];

    const isMissing = (fieldName, value) => {
      if (fieldName === "level") return !value || value === "N/A";
      if (fieldName === "category") return !value || value === "";
      if (fieldName === "type") return !value || String(value).trim() === "";
      if (fieldName === "institution")
        return !value || String(value).trim() === "";
      if (fieldName === "yearPengajian") return !value;
      if (fieldName === "filePengajian") return !value;
      return !value;
    };

    const isAnyFilledNonTrivial = (qual) => {
      const vals = [
        qual?.type && String(qual.type).trim() !== "",
        qual?.institution && String(qual.institution).trim() !== "",
        Boolean(qual?.yearPengajian),
        Boolean(qual?.filePengajian),
        Boolean(qual?.category),
        qual?.level && qual.level !== "N/A",
      ];
      return vals.some(Boolean);
    };

    qualifications.forEach((qual, idx) => {
      const isRequiredRow =
        idx === 0 ||
        qual.category === "AGAMA" ||
        // If user chooses BUKAN AGAMA, the row becomes mandatory to fill completely
        qual.category === "BUKAN AGAMA";
      const missing = [];

      if (isRequiredRow) {
        requiredFields.forEach((f) => {
          if (isMissing(f, qual?.[f])) missing.push(labelMap[f]);
        });
      } else {
        // For non-required rows: if user filled any field, enforce category + level present
        const anyFilled = isAnyFilledNonTrivial(qual);
        if (anyFilled) {
          if (isMissing("category", qual?.category))
            missing.push(labelMap.category);
          if (isMissing("level", qual?.level)) missing.push(labelMap.level);
        }
        // Detect truly empty rows to prompt deletion or completion
        const isCompletelyEmpty =
          (!qual?.category || qual.category === "") &&
          (!qual?.type || String(qual.type).trim() === "") &&
          (!qual?.level || qual.level === "" || qual.level === "N/A") &&
          (!qual?.institution || String(qual.institution).trim() === "") &&
          !qual?.yearPengajian &&
          !qual?.filePengajian;
        if (isCompletelyEmpty) {
          emptyRows.push(idx + 1);
        }
      }

      if (missing.length > 0) {
        missingByRow.push({ row: idx + 1, fields: missing });
      }
    });

    if (emptyRows.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Maklumat wajib belum lengkap",
        html: `<div class="text-left">Sila padam baris berikut atau lengkapkan semua maklumat:<ul class="list-disc ml-5 mt-2">${emptyRows
          .map((r) => `<li>Baris ${r}</li>`)
          .join("")}</ul></div>`,
      });
      setOpen(false);
      return;
    }

    if (missingByRow.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "Maklumat wajib belum lengkap",
        html: `<div class="text-left">Sila isi/muat naik ruangan berikut:<ul class="list-disc ml-5 mt-2">${missingByRow
          .map((r) => `<li>Baris ${r.row}: ${r.fields.join(", ")}</li>`)
          .join("")}</ul></div>`,
      });
      setOpen(false);
      return;
    }

    newArr = qualifications.map((qual) => qual.filePengajian) || [];

    // Find indices of rows that need upload
    const uploadIndices = qualifications
      ?.map((qual, i) => (qual.filePengajian ? i : null))
      .filter((i) => i !== null);

    if (uploadIndices.length === 0) {
      // No uploads needed, go to next page
      setOpen(false);
      nextPage(3);
      return;
    }

    // Start showing loader ONLY when uploads begin
    setOpen(true);

    let completed = 0;
    let hadUploadError = false;
    uploadIndices.forEach((i) => {
      const qual = kelayakan[i];
      formData = new FormData();
      formData.append("files", qual.filePengajian);

      axios
        .post(`${process.env.REACT_APP_API_URL}/api/upload/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            var percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
          },
        })
        .then((response) => {
          updatePengajianField(i, "qualificationID", response.data[0].id);
        })
        .catch((error) => {
          setOpen(false);
          console.error("Upload error:", error);
          Swal.fire({
            title: "Error",
            text: "Terdapat masalah semasa memuat naik fail. Sila cuba lagi.",
            icon: "error",
          });
          hadUploadError = true;
        })
        .finally(() => {
          completed++;
          if (completed === uploadIndices.length) {
            // All uploads done
            setOpen(false);
            if (!hadUploadError) {
              nextPage(3);
            }
          }
        });
    });
  }

  // Using utility functions from fileValidation.js

  useEffect(() => {
    if (
      login.pektaAppStatus !== "rejected" &&
      login.pektaAppStatus !== "none"
    ) {
      toast.warning(
        `Anda telah membuat permohonan PEKTA yang kini berstatus: ${login.pektaAppStatus} `,
        { position: toast.POSITION.TOP_CENTER }
      );
      navigate("/myprofile");
    }
  });

  const renderQualificationRow = (qualification, index) => (
    <div
      key={qualification.id}
      className="sm:flex flex-row mt-4 border-b border-gray-200 pb-5"
    >
      <div className="flex flex-col sm:mr-5 w-full">
        <label className="text-base">
          Bidang
          {isFieldRequired(index, qualification, "type") && (
            <label className="text-red-500">*</label>
          )}
        </label>
        <input
          value={qualification.type}
          onChange={(e) => handleChange(index, e)}
          className={`border-2 rounded-lg w-full p-1 mt-2 uppercase`}
          type="text"
          name="type"
        />
      </div>
      <div className="flex flex-col sm:mr-5 w-full">
        <label className="text-base">
          Kategori
          {isFieldRequired(index, qualification, "category") && (
            <label className="text-red-500">*</label>
          )}
        </label>
        <select
          className={`border-2 rounded-lg p-1 w-full mt-2 uppercase`}
          name="category"
          value={qualification.category || ""}
          onChange={(e) => handleChange(index, e)}
          disabled={index === 0}
        >
          <option value=""></option>
          <option value="AGAMA">Pengajian Islam</option>
          <option value="BUKAN AGAMA">Lain lain</option>
        </select>
      </div>
      <div className="flex flex-col sm:mr-5 w-full min-w-[160px]">
        <label className="text-base whitespace-nowrap">
          Kelulusan Akademik
          {isFieldRequired(index, qualification, "level") && (
            <label className="text-red-500">*</label>
          )}
        </label>
        <select
          className={`border-2 rounded-lg p-1 w-full mt-2 uppercase`}
          name="level"
          value={qualification.level}
          onChange={(e) => handleChange(index, e)}
        >
          <option value="N/A"></option>
          <option value="DOKTOR FALSAFAH">DOKTOR FALSAFAH</option>
          <option value="IJAZAH SARJANA">IJAZAH SARJANA</option>
          <option value="IJAZAH SARJANA MUDA">IJAZAH SARJANA MUDA</option>
          <option value="DIPLOMA">DIPLOMA</option>
          <option value="SIJIL">SIJIL</option>
          <option value="LAIN-LAIN">LAIN-LAIN</option>
        </select>
      </div>
      <div className="flex flex-col sm:mr-5">
        <label className="text-base">
          Institusi
          {isFieldRequired(index, qualification, "institution") && (
            <label className="text-red-500">*</label>
          )}
        </label>
        <input
          value={qualification.institution}
          onChange={(e) => handleChange(index, e)}
          className={`border-2 rounded-lg p-1 max-w-40 mt-2`}
          type="text"
          name="institution"
        />
      </div>
      <div className="flex flex-col">
        <label className="text-base mb-2">
          Tahun
          {isFieldRequired(index, qualification, "yearPengajian") && (
            <label className="text-red-500">*</label>
          )}
        </label>
        <DatePicker
          sx={{
            input: { "&::placeholder": { opacity: 1 }, height: "20px" },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#E5E7EB",
            },
            ".MuiOutlinedInput-notchedOutline": {
              borderRadius: "8px",
              borderColor:
                isFieldRequired(index, qualification, "yearPengajian") &&
                !qualification.yearPengajian
                  ? "#ef4444"
                  : "#E5E7EB",
            },
          }}
          slotProps={{ textField: { placeholder: "", size: "small" } }}
          className="MyDatePicker border-2 w-40"
          views={["year"]}
          maxDate={dayjs()}
          value={
            !qualification.yearPengajian
              ? null
              : dayjs(qualification.yearPengajian)
          }
          onChange={(e) => {
            updatePengajianField(index, "yearPengajian", e.$d.toISOString());
          }}
        />
      </div>
      <div className="flex items-center gap-2 ml-4">
        <label
          htmlFor={`pengajian${index}`}
          className="w-32 h-10 border-2 pl-1 mt-8 rounded-lg cursor-pointer flex items-center"
        >
          <img
            className="h-5 w-5 float-left mr-2 bg-fixed"
            src={qualification.Ipengajian}
            alt=""
          />
          {qualification.pengajian}
          <input
            id={`pengajian${index}`}
            accept="image/*,application/pdf"
            className="border-2 hidden"
            type="file"
            onChange={(e) => {
              const file = e.target.files[0];
              if (file) {
                const validation = validateFile(
                  file,
                  validationConfigs.default
                );
                if (!validation.valid) {
                  Swal.fire({
                    icon: "error",
                    title: "Jenis Fail Tidak Sah",
                    text: validation.message,
                  });
                  e.target.value = ""; // Clear the input
                  return;
                }

                const filename = shortenFilename(
                  e.target.value
                    .toString()
                    .split(/(\\|\/)/g)
                    .pop()
                );
                const imageFile = check;

                updatePengajianField(index, "pengajian", filename);
                updatePengajianField(index, "Ipengajian", imageFile);
                updatePengajianField(index, "filePengajian", file);
              }
            }}
          />
        </label>
        {index > 0 && (
          <button
            onClick={() => removeQualification(index)}
            className="mt-8 px-3 py-1 bg-red-500 text-white rounded-lg"
          >
            Padam
          </button>
        )}
      </div>
    </div>
  );

  return (
    <>
      <Header />
      <PektaHeader page={"2"} />
      <Container maxWidth={false} disableGutters>
        <div className="mb-10 sm:flex justify-center">
          <div className="mt-10 p-4 w-full sm:mx-20">
            <div className="flex justify-between items-start">
              <div>
                <p className="text-4xl">Kelulusan Akademik</p>
                <p className="text-sm text-gray-500 mt-1">
                  Dokumen dengan <span className="text-red-500">*</span> wajib
                  di isi dengan lengkap
                </p>
              </div>
              <button
                onClick={addQualification}
                className="px-4 py-2 bg-green-600 text-white rounded-lg"
              >
                Tambah
              </button>
            </div>
            <br />
            {qualifications.map((qualification, index) =>
              renderQualificationRow(qualification, index)
            )}
          </div>
          <div className="flex justify-center mt-4"></div>
        </div>
        <div className="text-center sm:mx-24 my-16 px-3 flex justify-between">
          <button
            className="border-2 bg-green-600 text-white rounded-lg p-2"
            onClick={() => {
              nextPage(1);
            }}
          >
            ❮ Kembali
          </button>
          <button
            className="border-2 bg-green-600 text-white rounded-lg p-2"
            onClick={handleUpload}
          >
            Seterusnya ❯
          </button>
        </div>
      </Container>
      <Modal
        open={open}
        onClose={() => console.log("check")}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="flex justify-center md:mt-40 lg:mt-48 xl:mt-56">
          <CircularProgress color="success" size={200} />
        </div>
      </Modal>
    </>
  );
}
